import api from "../services/api";

export const login = async (email, password) => {
  try {
    const formData = new URLSearchParams();
    formData.append("username", email);
    formData.append("password", password);

    const response = await api.post("auth/admin/login", formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    });
    if (response.status === 200 && response.data.access_token) {
      localStorage.setItem("access_token", response.data.access_token);

      if (response?.data?.error === "Account is inactive. Please activate your account to log in.") {
        history.push("/auth/change-password");
        return { error: "Account is inactive. Please activate your account to log in." };
      }

      const csrfToken = response.headers.get('X-Csrf-Token');

      if (csrfToken) {
        document.cookie = `csrf_token=${csrfToken}; path=/; secure; samesite=strict`;
      }
      return response.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Login Failed:", error.message || error);
    return { error: error.response?.data?.detail || "Login failed" };
  }
};

export const changePassword = async (email, currentPassword, newPassword) => {
  try {
    // Construct the URL with query parameters
    const url = `auth/admin/change-password?email=${encodeURIComponent(email)}&current_password=${encodeURIComponent(currentPassword)}&new_password=${encodeURIComponent(newPassword)}`;

    const response = await api.post(url, null, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    });

    if (response.status === 200 && response.data.success) {
      return { success: true, message: response.data.message };
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Password Change Failed:", error.message || error);
    return { error: error.response?.data?.detail || "Password change failed" };
  }
};

//Confirm Password
export const confirmAdminPassword = async (password) => {
  try {
    const encodedPassword = encodeURIComponent(password);

    const response = await api.post(
      `auth/admin/confirm-password?password=${encodedPassword}`,
      {
        withCredentials: true,
      }
    );

    if (response.status === 200 && response.data.success) {
      return { success: true, message: response.data.message };
    } else {
      console.warn("Unexpected Response:", response);
      return { error: response.data?.message || "Unexpected server response" };
    }
  } catch (error) {
    console.error("Password Confirmation Failed:", error.message || error);
    return {
      error: error.response?.data?.detail || "Password confirmation failed",
    };
  }
};



//Verify OTP Function
export const verifyOtp = async ({ user_id, otp }) => {
  try {
    console.log("Verifying OTP with:", { user_id, otp });
    const response = await api.post("auth/verify-otp", {
      user_id,
      otp,
    });

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data };
    } else {
      console.warn("OTP Verification Unexpected Response:", response);
      return { error: response.data?.detail || "OTP verification failed" };
    }
  } catch (error) {
    console.error("OTP Verification Failed:", error.message || error);
    return {
      error: error.response?.data?.detail || "OTP verification failed",
    };
  }
};

// Delete Account Function
export const deleteAccount = async (user_id) => {
  try {
    const url = `auth/privacy/delete-account?user_id=${encodeURIComponent(user_id)}`;

    const response = await api.delete(url, {
      withCredentials: true,
    });

    if (response.status === 200) {
      return { success: true, message: "Account deleted successfully" };
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Delete Account Failed:", error.message || error);
    return { error: error.response?.data?.detail || "Account deletion failed" };
  }
};
